var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[(_vm.href)?_c('router-link',{attrs:{"to":_vm.href,"aria-label":_vm.label}},[_vm._t("default")],2):_c('button',_vm._g({attrs:{"type":_vm.buttonType,"aria-label":_vm.label}},_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }